import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f1419] via-[#1a1a1a] to-[#0a0a0a]"></div>
      
      <div className="absolute inset-0 opacity-5">
        <div className="absolute right-0 bottom-0 w-1/2 h-1/2">
          <svg className="w-full h-full" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
                <path d="M 10 0 L 0 0 0 10" fill="none" stroke="#c9a96e" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100" height="100" fill="url(#grid)" />
          </svg>
        </div>
      </div>

      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZmlsdGVyIGlkPSJub2lzZSI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9IjAuOSIgbnVtT2N0YXZlcz0iNCIgLz48L2ZpbHRlcj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWx0ZXI9InVybCgjbm9pc2UpIiBvcGFjaXR5PSIwLjA1IiAvPjwvc3ZnPg==')] opacity-30"></div>

      <div className="relative z-10 w-full px-6 lg:px-12 py-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className={`lg:w-[55%] transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'}`}>
            <div className="relative">
              <h1 className="text-[12vw] lg:text-[10vw] font-black leading-none bg-gradient-to-br from-[#d4c5b9] via-[#c9a96e] to-[#d4c5b9] bg-clip-text text-transparent">
                KENJI<br />TANAKA
              </h1>
              <div className="absolute -bottom-4 left-0">
                <p className="text-sm lg:text-base text-[#c9a96e] tracking-[0.3em] font-light">
                  CREATIVE DIRECTOR / UI DESIGNER
                </p>
              </div>
            </div>
          </div>

          <div className={`lg:w-[45%] space-y-8 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}>
            <div className="space-y-6">
              <p className="text-base lg:text-lg leading-relaxed text-[#d4c5b9]/90">
                <span className="text-5xl float-left mr-3 mt-1 text-[#c9a96e] font-serif">東</span>
                京を拠点に活動するクリエイティブディレクター兼UIデザイナーです。ブランド体験の設計からデジタルプロダクトのデザインまで、ユーザーの心に響く体験を創造することに情熱を注いでいます。デザインは単なる視覚表現ではなく、ビジネス課題を解決し、人々の生活を豊かにする手段だと考えています。
              </p>
            </div>

            <div className="flex items-center justify-between py-8 border-t border-b border-[#c9a96e]/20">
              <div className="text-center">
                <div className="text-5xl lg:text-6xl font-bold text-[#c9a96e]">150+</div>
                <div className="text-xs lg:text-sm text-[#d4c5b9]/70 mt-2">Projects</div>
              </div>
              <div className="w-px h-16 bg-[#c9a96e]/30"></div>
              <div className="text-center">
                <div className="text-5xl lg:text-6xl font-bold text-[#c9a96e]">80+</div>
                <div className="text-xs lg:text-sm text-[#d4c5b9]/70 mt-2">Clients</div>
              </div>
              <div className="w-px h-16 bg-[#c9a96e]/30"></div>
              <div className="text-center">
                <div className="text-5xl lg:text-6xl font-bold text-[#c9a96e]">25+</div>
                <div className="text-xs lg:text-sm text-[#d4c5b9]/70 mt-2">Awards</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#portfolio"
                className="flex-1 px-8 py-4 bg-[#1a1a1a] text-[#d4c5b9] rounded-2xl text-center font-medium hover:bg-[#c9a96e] hover:text-[#1a1a1a] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                View Works
              </a>
              <a
                href="#contact"
                className="flex-1 px-8 py-4 border-2 border-[#c9a96e] text-[#c9a96e] rounded-2xl text-center font-medium hover:bg-[#c9a96e] hover:text-[#1a1a1a] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Contact Me
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-[#c9a96e]"></i>
      </div>
    </section>
  );
}